import { Button, Divider, notification, Popconfirm } from 'antd';
import { weatherApi } from 'api/weatherApi';
// import { envSensorApi } from 'api/envSensor';
import { inverterInfo, ObjectGatewayInfo } from 'models';
import moment from 'moment';
import * as React from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import style from './EnvironmentInfo.module.scss';
export interface EnvironmentInfoProps {
  environment: inverterInfo;
  setEnvironment: (object: inverterInfo | undefined) => void;
}

export default function EnvironmentInfo(props: EnvironmentInfoProps) {
  const { environment, setEnvironment } = props;
  const [envSensor, setEnvSensor] = React.useState<ObjectGatewayInfo | undefined>();
  const [showPassword, setShowPassword] = React.useState<boolean>(false);

  React.useEffect(() => {
    setEnvSensor({
      access_token: environment.access_token ? environment.access_token : '',
      id: environment.id,
      location: '',
      model: environment.model,
      label: environment.label,
      name: environment.code,
      serial_number: environment.serial_number ? environment.serial_number : '',
      type: 'env_sensor-MIND',
      active: environment.active,
      last_activity_time: environment.last_activity_time,
      last_connect_time: environment.last_connect_time,
      last_disconnect_time: environment.last_disconnect_time,
      rssi: -18,
      status: 'normal',
    });
  }, [environment]);

  const confirm = async () => {
    try {
      await weatherApi.remove(environment.id);
      setEnvSensor(undefined);
      setEnvironment(undefined);
      openNotificationWithIcon('success', 'Remove sensor successfully');
    } catch (error) {
      openNotificationWithIcon('error', 'Remove sensor Failed!');
    }
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };
  return (
    <>
      {envSensor && (
        <div className={style.root}>
          <div className={style.label_environment}>Weather sensor</div>{' '}
          <div
            style={{
              height: 'calc(100% - 90px)',
              textAlign: 'start',
              overflowY: 'auto',
              paddingLeft: '10px',
            }}
          >
            <Divider orientation="left" plain style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Information
            </Divider>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Code</div>
              <div className={style.content_item_info}>{envSensor.name}</div>
            </div>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Label</div>
              <div className={style.content_item_info}>{envSensor.label}</div>
            </div>

            <div className={style.item_info}>
              <div className={style.label_item_info}>Model</div>
              <div className={style.content_item_info}>{envSensor.model}</div>
            </div>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Serial number</div>
              <div className={style.content_item_info}>{envSensor.serial_number}</div>
            </div>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Access token</div>
              <div
                className={style.content_item_info}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {showPassword ? (
                  <>
                    {envSensor?.access_token}
                    <AiFillEye
                      style={{ marginLeft: '10px', cursor: 'pointer' }}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  </>
                ) : (
                  <>
                    **********************
                    <AiFillEyeInvisible
                      style={{ marginLeft: '10px', cursor: 'pointer' }}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  </>
                )}
              </div>
            </div>
            <Divider orientation="left" plain style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Status
            </Divider>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Active</div>
              <div className={style.content_item_info}>
                <div className={style.color_item_info}>{envSensor.active ? 'True' : 'False'}</div>
              </div>
            </div>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Sensor status</div>
              <div className={style.content_item_info}>
                <div className={style.color_item_info}>{envSensor.sensor_status}</div>
              </div>
            </div>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Last activity time</div>
              <div className={style.content_item_info}>
                {envSensor.last_activity_time !== null
                  ? moment(envSensor.last_activity_time).format('YYYY-MM-DD HH:mm:ss')
                  : 'N/A'}
              </div>
            </div>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Last connect time</div>
              <div className={style.content_item_info}>
                {envSensor.last_connect_time !== null
                  ? moment(envSensor.last_connect_time).format('YYYY-MM-DD HH:mm:ss')
                  : 'N/A'}
              </div>
            </div>
            <div className={style.item_info}>
              <div className={style.label_item_info}>Last disconnect time</div>
              <div className={style.content_item_info}>
                {envSensor.last_disconnect_time !== null
                  ? moment(envSensor.last_disconnect_time).format('YYYY-MM-DD HH:mm:ss')
                  : 'N/A'}
              </div>
            </div>
            {/* <div className={style.item_info}>
              <div className={style.label_item_info}>RSSI wifi</div>
              <div className={style.content_item_info}>
                <div className={style.color_item_info}>
                  {envSensor.rssi ? `${envSensor.rssi} dBm` : 'N/A'}
                </div>
              </div>
            </div> */}
            <Popconfirm
              placement="top"
              title={'Are you sure to delete this sensor?'}
              onConfirm={confirm}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary" danger shape="round" size="middle" style={{ margin: '10px' }}>
                Delete
              </Button>
            </Popconfirm>
          </div>
        </div>
      )}
    </>
  );
}
